import { c as _c } from "react/compiler-runtime";
import { HeroLeadPanel } from "./HeroLeadPanel";
import { TerraLink } from "@/components/terra/component/TerraLink/TerraLink";
import { SimpleCarousel } from "@/components/terra/component/SimpleCarousel/SimpleCarousel";
import { VideoCovered } from "@/components/terra/component/VideoCovered/VideoCovered";
import type { MappedHeroVideo } from "@/components/terra/utils/mapContentfulVideo";
import { HeroScrollToContent } from "./HeroScrollToContent";
import { colorSettingDetection } from "../../utils/functions";
import type { BreadcrumbCrumb } from "@/lib/breadcrumbs";
import type { HeroHeaderSize } from "@/lib/heroHeaderSize";
import "./HeroLead.css";
export type ImageProps = {
  title: string;
  height: number;
  width: number;
  x: number;
  y: number;
  url: string;
  altText?: string;
  focusArea?: string;
};
export interface HeroLeadContent {
  eyebrow?: string;
  header?: string;
  subheader?: string;
  description?: string;
  backgroundImage?: ImageProps;
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  buttons?: TerraLink[];
  isHeaderBig?: boolean;
  /** Overrides isHeaderBig when set (see MXP-2076). */
  headerSize?: HeroHeaderSize;
  isWrapped?: boolean;
  LinkComponent?: React.Component<any, any>;
}
export interface HeroLeadProps {
  content: any[];
  headerElement?: "h1" | "h2";
  /**
   * Extra class name(s) appended to the rendered header element. Used e.g.
   * by pages that need a stable, page-owned hook (like `caseStudy-header`)
   * on the heading regardless of which hero variant is rendering it.
   */
  headerClassName?: string;
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  /**
   * Contentful display mode: `"lead"` = default lead layout; `"simple"` = flat/simple hero treatment.
   */
  heroStyle?: "lead" | "simple";
  isSearchEnabled?: boolean;
  searchPlaceholderText?: string;
  onSearch?: (value: string) => void;
  LinkComponent?: React.Component<any, any>;
  componentImagePriority?: "high" | "auto" | "low";
  isLCP?: boolean;
  video?: MappedHeroVideo;
  forceFullHeightVideo?: boolean;
  showScrollToContent?: boolean;
  breadcrumbs?: BreadcrumbCrumb[];
  breadcrumbDarkMode?: boolean;
}
export interface HeroContentProps {
  content: any[];
  headerElement?: "h1" | "h2";
  headerClassName?: string;
  heroStyle?: "lead" | "simple";
  isSearchEnabled?: boolean;
  searchPlaceholderText?: string;
  onSearch?: (value: string) => void;
  LinkComponent?: React.Component<any, any>;
  componentImagePriority?: "high" | "auto" | "low";
  isLCP?: boolean;
  videoPresent?: boolean;
  breadcrumbs?: BreadcrumbCrumb[];
  breadcrumbDarkMode?: boolean;
}
const HeroContent = t0 => {
  const $ = _c(41);
  const {
    content,
    headerElement: t1,
    headerClassName,
    heroStyle: t2,
    isSearchEnabled,
    searchPlaceholderText,
    LinkComponent,
    componentImagePriority,
    isLCP,
    videoPresent,
    breadcrumbs,
    breadcrumbDarkMode
  } = t0;
  const headerElement = t1 === undefined ? "h1" : t1;
  const heroStyle = t2 === undefined ? "lead" : t2;
  const wedgeTrackClass = heroStyle === "lead" && videoPresent === false ? "[clip-path:polygon(0_0,100%_0,100%_calc(100%-50px),50%_100%,0_calc(100%-50px))]" : undefined;
  if (content.length > 1) {
    let t3;
    if ($[0] !== LinkComponent || $[1] !== breadcrumbDarkMode || $[2] !== breadcrumbs || $[3] !== componentImagePriority || $[4] !== content || $[5] !== headerClassName || $[6] !== headerElement || $[7] !== heroStyle || $[8] !== isLCP || $[9] !== isSearchEnabled || $[10] !== searchPlaceholderText || $[11] !== videoPresent) {
      let t4;
      if ($[13] !== LinkComponent || $[14] !== breadcrumbDarkMode || $[15] !== breadcrumbs || $[16] !== componentImagePriority || $[17] !== headerClassName || $[18] !== headerElement || $[19] !== heroStyle || $[20] !== isLCP || $[21] !== isSearchEnabled || $[22] !== searchPlaceholderText || $[23] !== videoPresent) {
        t4 = (item, index) => <HeroLeadPanel key={`hero-lead-${index}`} {...item} headerElement={index == 0 ? headerElement : "h2"} headerClassName={index == 0 ? headerClassName : undefined} isSearchEnabled={isSearchEnabled || item.isSearchEnabled} searchPlaceholderText={searchPlaceholderText || item.searchPlaceholderText} heroStyle={heroStyle} LinkComponent={LinkComponent} componentImagePriority={componentImagePriority} isLCP={index === 0 ? isLCP : false} videoPresent={videoPresent} breadcrumbs={breadcrumbs} breadcrumbDarkMode={breadcrumbDarkMode} />;
        $[13] = LinkComponent;
        $[14] = breadcrumbDarkMode;
        $[15] = breadcrumbs;
        $[16] = componentImagePriority;
        $[17] = headerClassName;
        $[18] = headerElement;
        $[19] = heroStyle;
        $[20] = isLCP;
        $[21] = isSearchEnabled;
        $[22] = searchPlaceholderText;
        $[23] = videoPresent;
        $[24] = t4;
      } else {
        t4 = $[24];
      }
      t3 = content.map(t4);
      $[0] = LinkComponent;
      $[1] = breadcrumbDarkMode;
      $[2] = breadcrumbs;
      $[3] = componentImagePriority;
      $[4] = content;
      $[5] = headerClassName;
      $[6] = headerElement;
      $[7] = heroStyle;
      $[8] = isLCP;
      $[9] = isSearchEnabled;
      $[10] = searchPlaceholderText;
      $[11] = videoPresent;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[25] !== t3 || $[26] !== wedgeTrackClass) {
      t4 = <SimpleCarousel autoplay={true} autoplaySpeed={13000} trackClassName={wedgeTrackClass} dotsClassName="absolute! bottom-20 max-sm:bottom-12 left-0 right-0 z-20 mt-0 [&>button]:hidden [&>div]:bg-white/80 [&>div]:rounded-full [&>div]:px-2 [&>div]:py-1 [&>div]:mx-auto [&>div]:w-fit">{t3}</SimpleCarousel>;
      $[25] = t3;
      $[26] = wedgeTrackClass;
      $[27] = t4;
    } else {
      t4 = $[27];
    }
    return t4;
  }
  const t3 = isSearchEnabled || content[0]?.isSearchEnabled;
  const t4 = searchPlaceholderText || content[0]?.searchPlaceholderText;
  let t5;
  if ($[28] !== LinkComponent || $[29] !== breadcrumbDarkMode || $[30] !== breadcrumbs || $[31] !== componentImagePriority || $[32] !== content[0] || $[33] !== headerClassName || $[34] !== headerElement || $[35] !== heroStyle || $[36] !== isLCP || $[37] !== t3 || $[38] !== t4 || $[39] !== videoPresent) {
    t5 = <><HeroLeadPanel {...content[0]} headerElement={headerElement} headerClassName={headerClassName} isSearchEnabled={t3} searchPlaceholderText={t4} heroStyle={heroStyle} LinkComponent={LinkComponent} componentImagePriority={componentImagePriority} isLCP={isLCP} videoPresent={videoPresent} breadcrumbs={breadcrumbs} breadcrumbDarkMode={breadcrumbDarkMode} /></>;
    $[28] = LinkComponent;
    $[29] = breadcrumbDarkMode;
    $[30] = breadcrumbs;
    $[31] = componentImagePriority;
    $[32] = content[0];
    $[33] = headerClassName;
    $[34] = headerElement;
    $[35] = heroStyle;
    $[36] = isLCP;
    $[37] = t3;
    $[38] = t4;
    $[39] = videoPresent;
    $[40] = t5;
  } else {
    t5 = $[40];
  }
  return t5;
};
export const HeroLead = t0 => {
  const $ = _c(56);
  const {
    content,
    headerElement: t1,
    headerClassName,
    presetTheme,
    heroStyle: t2,
    isSearchEnabled: t3,
    searchPlaceholderText,
    onSearch,
    LinkComponent,
    componentImagePriority,
    isLCP,
    video,
    forceFullHeightVideo: t4,
    showScrollToContent: t5,
    breadcrumbs,
    breadcrumbDarkMode
  } = t0;
  const headerElement = t1 === undefined ? "h1" : t1;
  const heroStyle = t2 === undefined ? "lead" : t2;
  const isSearchEnabled = t3 === undefined ? false : t3;
  const forceFullHeightVideo = t4 === undefined ? false : t4;
  const showScrollToContent = t5 === undefined ? false : t5;
  const t6 = !!video?.videoId;
  let t7;
  if ($[0] !== LinkComponent || $[1] !== breadcrumbDarkMode || $[2] !== breadcrumbs || $[3] !== componentImagePriority || $[4] !== content || $[5] !== headerClassName || $[6] !== headerElement || $[7] !== heroStyle || $[8] !== isLCP || $[9] !== isSearchEnabled || $[10] !== onSearch || $[11] !== searchPlaceholderText || $[12] !== t6) {
    t7 = {
      content,
      headerElement,
      headerClassName,
      heroStyle,
      isSearchEnabled,
      searchPlaceholderText,
      onSearch,
      LinkComponent,
      componentImagePriority,
      isLCP,
      videoPresent: t6,
      breadcrumbs,
      breadcrumbDarkMode
    };
    $[0] = LinkComponent;
    $[1] = breadcrumbDarkMode;
    $[2] = breadcrumbs;
    $[3] = componentImagePriority;
    $[4] = content;
    $[5] = headerClassName;
    $[6] = headerElement;
    $[7] = heroStyle;
    $[8] = isLCP;
    $[9] = isSearchEnabled;
    $[10] = onSearch;
    $[11] = searchPlaceholderText;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const sharedContentProps = t7 as const;
  const multi = content.length > 1;
  const componentTheme = presetTheme ? presetTheme : content?.[0]?.presetTheme ? content?.[0]?.presetTheme : undefined;
  const overlayTheme = colorSettingDetection(presetTheme || "");
  const overlayClass = overlayTheme === "t2-color-setting--dark" ? `${componentTheme} absolute inset-0 md:z-[3] pointer-events-none t2-hero-lead--overlay-dark` : overlayTheme === "t2-color-setting--light" ? `${componentTheme} absolute inset-0 md:z-[3] pointer-events-none t2-hero-lead--overlay-light` : undefined;
  let t8;
  if ($[14] !== overlayClass || $[15] !== sharedContentProps?.content || $[16] !== sharedContentProps?.videoPresent) {
    t8 = sharedContentProps?.videoPresent && sharedContentProps?.content[0] ? <div className={overlayClass} /> : null;
    $[14] = overlayClass;
    $[15] = sharedContentProps?.content;
    $[16] = sharedContentProps?.videoPresent;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const videoOverlay = t8;
  const videoPopulated = !!video?.videoId;
  const fullHeightVideo = videoPopulated && forceFullHeightVideo;
  const renderScrollToContent = videoPopulated && showScrollToContent;
  let t9;
  if ($[18] !== forceFullHeightVideo || $[19] !== fullHeightVideo || $[20] !== video || $[21] !== videoPopulated) {
    t9 = videoPopulated ? <div className={fullHeightVideo ? "t2-hero-lead__video" : "relative z-[3] w-full"}><VideoCovered videoId={video.videoId} image={video.image} fullBackgroundVideo={true} forceFullHeightVideo={forceFullHeightVideo} /></div> : null;
    $[18] = forceFullHeightVideo;
    $[19] = fullHeightVideo;
    $[20] = video;
    $[21] = videoPopulated;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const videoSection = t9;
  if (heroStyle === "simple") {
    const t10 = `${componentTheme ?? ""}${fullHeightVideo ? " t2-hero-lead--full-height-video relative overflow-hidden" : ""}`;
    const t11 = fullHeightVideo ? "relative z-[3] h-full min-h-0" : undefined;
    let t12;
    if ($[23] !== sharedContentProps) {
      t12 = <HeroContent {...sharedContentProps} />;
      $[23] = sharedContentProps;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t13;
    if ($[25] !== t11 || $[26] !== t12) {
      t13 = <div className={t11}>{t12}</div>;
      $[25] = t11;
      $[26] = t12;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    let t14;
    if ($[28] !== t10 || $[29] !== t13 || $[30] !== videoOverlay || $[31] !== videoSection) {
      t14 = <div className={t10} data-testid="hero-lead">{videoSection}{t13}{videoOverlay}</div>;
      $[28] = t10;
      $[29] = t13;
      $[30] = videoOverlay;
      $[31] = videoSection;
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    return t14;
  }
  const heroWrapperClasses = videoPopulated ? fullHeightVideo ? "t2-hero-lead--full-height-video w-full relative overflow-hidden" : "w-full relative" : `pb-[50px] relative ${componentTheme ?? ""}`;
  let t10;
  if ($[33] !== renderScrollToContent) {
    t10 = renderScrollToContent ? {
      "data-page-first-hero": ""
    } : {};
    $[33] = renderScrollToContent;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== renderScrollToContent) {
    t11 = renderScrollToContent && <HeroScrollToContent />;
    $[35] = renderScrollToContent;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  const t12 = videoPopulated ? fullHeightVideo ? "relative z-[3] h-full min-h-0 w-full" : "relative md:absolute py-4 inset-0 z-[3] flex justify-center" : "drop-shadow-[0_15px_10px_rgba(0,0,0,0.2)]";
  let t13;
  if ($[37] !== multi || $[38] !== videoPopulated) {
    t13 = multi || videoPopulated ? undefined : {
      clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 50px), 50% 100%, 0 calc(100% - 50px))"
    };
    $[37] = multi;
    $[38] = videoPopulated;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  const t14 = `${videoPopulated ? "w-full h-full flex justify-center bg-transparent" : ""}`;
  let t15;
  if ($[40] !== sharedContentProps) {
    t15 = <HeroContent {...sharedContentProps} />;
    $[40] = sharedContentProps;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t13 || $[43] !== t14 || $[44] !== t15) {
    t16 = <div style={t13} className={t14}>{t15}</div>;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t12 || $[47] !== t16) {
    t17 = <div className={t12}>{t16}</div>;
    $[46] = t12;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== heroWrapperClasses || $[50] !== t10 || $[51] !== t11 || $[52] !== t17 || $[53] !== videoOverlay || $[54] !== videoSection) {
    t18 = <div className={heroWrapperClasses} data-testid="hero-lead" {...t10}>{videoSection}{videoOverlay}{t11}{t17}</div>;
    $[49] = heroWrapperClasses;
    $[50] = t10;
    $[51] = t11;
    $[52] = t17;
    $[53] = videoOverlay;
    $[54] = videoSection;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  return t18;
};